import React from "react";
import DesktopPagination from "./desktopPagination";
import MobilePagination from "./mobilePagination";
import useMediaQuery from "../../hooks/useMediaQuery";

const Pagination = ({
  totalPages,
  limitData,
  selectedPage,
  handlePagination,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  if (isMobile) {
    return (
      <MobilePagination
        totalPages={totalPages}
        limitData={limitData}
        selectedPage={selectedPage}
        handlePagination={handlePagination}
      />
    );
  } else {
    return (
      <DesktopPagination
        totalPages={totalPages}
        limitData={limitData}
        selectedPage={selectedPage}
        handlePagination={handlePagination}
      />
    );
  }
};

export default Pagination;
